import { Observable } from 'rxjs';

import { HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';

import { publicUrls } from '../services/api/api.service';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { SnackbarService } from '../services/snackbar-service/snackbar.service';

export const keycloakHttpInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const _authenticationService = inject(AuthenticationService);
  const _snackbarService = inject(SnackbarService);

  const isPublic = publicUrls.some(url => {
    try {
      return new URL(req.url).pathname === url;
    } catch {
      return false;
    }
  });

  return new Observable<HttpEvent<unknown>>(subscriber => {
    let headers = req.headers;

    if (_authenticationService.isLoggedIn()) {
      headers = headers.set('Authorization', `Bearer ${_authenticationService.getToken()}`);
    } else if (!isPublic) {
      _snackbarService.openFailureSnackBar('Sem token válido. Por favor, faça login novamente');

      _authenticationService.logout();
      subscriber.error(new Error('Not authenticated'));
      return;
    }

    const isFormData = req.body instanceof FormData;
    if (!isFormData) {
      headers = headers.set('Content-Type', 'application/json');
    }

    const clonedRequest = req.clone({ headers });

    next(clonedRequest).subscribe({
      next: (event) => subscriber.next(event),
      error: (error) => {
        if (error.status === 401 || error.status === 403) {
          _snackbarService.openFailureSnackBar('Sessão expirada. Por favor, faça login novamente');
          _authenticationService.logout();
        }
        subscriber.error(error);
      },
      complete: () => subscriber.complete()
    });

    return () => {
      // Cleanup subscription
      subscriber.unsubscribe();
    };
  });
};
